// Textos de la interfaz en los dos idiomas, con las mismas claves. Las
// etiquetas del HUD van en mayusculas y telegraficas; los numeros no viven
// aqui, se componen en el JSX, asi que ninguna clave necesita interpolacion.
//
// Los textos largos (los popups explicativos) viven en hud/explicaciones.*.js,
// porque son prosa con marcado y se escriben nativos en cada idioma.
//
// El castellano conserva "primer/segundo orden", el vocabulario de la memoria
// que origino el proyecto; el ingles usa el del paper (commuter-adjusted
// accessibility) y nombra los dos anclajes, casa y trabajo, que es lo que
// permite leer el dorado y el rojo sin conocer el concepto.
//
// El nombre "campo A.T." es un prestamo de Neon Genesis Evangelion, donde el
// A.T. Field es una barrera que impide el contacto. Aqui las iniciales son
// Accesibilidad y Trabajo, y el campo mide lo contrario: el contacto posible
// con los servicios, contando a quienes llegan a trabajar. La sigla cierra en
// castellano, asi que en los dos idiomas se deja sin expandir en la marca y se
// explica en el "acerca de".

const es = {
  'idioma.otro': 'EN',
  'idioma.cambiar': 'Switch to English',

  'comun.residentes': 'RESIDENTES',
  'comun.trabajadores': 'TRABAJADORES',
  'comun.accesibilidad': 'ACCESIBILIDAD',
  'comun.tipologia': 'TIPOLOGIA',
  'comun.colapsar': 'Plegar el panel',
  'comun.expandir': 'Desplegar el panel',
  'comun.cargando': 'CARGANDO DATOS...',
  'comun.cargandoCorto': 'Cargando...',
  'comun.error': 'ERROR AL CARGAR DATOS',

  'orden.primero': 'PRIMER ORDEN',
  'orden.segundo': 'SEGUNDO ORDEN',

  'necesidad.farmacias': 'FARMACIAS',
  'necesidad.supermercados': 'SUPERMERCADOS',
  'necesidad.bancos': 'BANCOS',
  'necesidad.salud': 'SALUD',
  'necesidad.farmacias.corta': 'FAR',
  'necesidad.supermercados.corta': 'SUP',
  'necesidad.bancos.corta': 'BAN',
  'necesidad.salud.corta': 'SAL',

  'app.marca': 'LOICA // CAMPO A.T. DE SANTIAGO',
  'app.marcaCorta': 'LOICA // CAMPO A.T.',
  'app.acercaAria': 'Acerca de esta visualización',
  'app.selectorAlfa': 'DEMANDA TRABAJADORA (α)',
  'app.codigoAcerca': 'SISTEMA // ACERCA DE',
  'app.acercaMd': 'acerca-de.md',
  'app.acercaError': 'No se pudo cargar el texto.',
  'app.titulo': 'Campo A.T. de Santiago - Accesibilidad y Trabajo',

  'tooltip.residentes': 'residentes',
  'tooltip.trabajadores': 'trabajadores',
  'tooltip.caminata': 'min a pie',

  'panel.espera': 'SELECCIONE UNA CELDA',
  'panel.esperaMovil': 'TOQUE UNA CELDA',
  'panel.sector': 'SECTOR',
  'panel.completo': 'ANALISIS COMPLETO',
  'panel.escaneando': 'ESCANEANDO...',
  'panel.progresoAria': 'Minutos de caminata escaneados',
  'panel.min': 'MIN',
  'panel.tabsAria': 'Secciones del panel',
  'panel.tabAnalisis': 'ANALISIS',
  'panel.tabServicios': 'SERVICIOS',
  'panel.puntuacion': 'PUNTUACION E2SFCA',
  'panel.puntuacionPorAlfa': 'PUNTUACION POR α',
  'panel.celda': 'CELDA',
  'panel.ciudad': 'CIUDAD',
  'panel.tipologia': 'TIPOLOGIA',
  'panel.retenida': 'ACCESIBILIDAD RETENIDA',
  'panel.peso': 'PESO DE LA POBLACION TRABAJADORA',
  'panel.poblacion': 'POBLACION DE LA CELDA',
  'panel.serviciosEncendidos': 'SERVICIOS ENCENDIDOS',
  'panel.sinSenales': 'SIN SEÑALES AUN',
  'panel.serviciosAlcanzados': 'SERVICIOS ALCANZADOS',
  'panel.trabajadoresResidentes': 'TRABAJADORES RESIDENTES',
  'panel.celdasTrabajo': 'CELDAS DE TRABAJO',
  'panel.serviciosDesdeTrabajo': 'SERVICIOS DESDE EL TRABAJO',
  'panel.soloDesdeTrabajo': 'SOLO ALCANZABLES DESDE EL TRABAJO',
  'panel.soloDesdeTrabajoCorto': 'SOLO DESDE EL TRABAJO',
  'panel.servicios': 'SERVICIOS',
  'panel.destino': 'DESTINO',
  'panel.sinAsignacion': 'SIN DATOS DE ASIGNACION CASA-TRABAJO',
  'panel.verEnMapa': 'VER EN EL MAPA',

  'leyenda.titulo': 'COLOR DE LOS HEXAGONOS',
  'leyenda.acerca': 'ACERCA DE',
  'leyenda.movimientoSi': 'ANIMACIÓN: SÍ',
  'leyenda.movimientoNo': 'ANIMACIÓN: NO',
  'leyenda.movimientoAria': 'Activar o desactivar la animación del escaneo',
  'leyenda.residentesPorCelda': 'RESIDENTES POR CELDA',
  'leyenda.trabajadoresPorCelda': 'TRABAJADORES POR CELDA',
  'leyenda.accesibilidadRampa': 'ACCESIBILIDAD (E2SFCA)',
  'leyenda.descPoblacion':
    'El color mide cuántas personas viven en la celda, según la cartografía del Censo 2024.',
  'leyenda.descTrabajadores':
    'El color mide cuántas personas trabajan en la celda, estimadas desde el Censo 2024 con un prior espacial dentro de cada comuna.',
  'leyenda.descAccesibilidad':
    'El color mide qué tan bien conectada está la celda a farmacias, supermercados, bancos y salud caminando, ponderando la oferta contra la demanda. El nivel depende de α.',
  'leyenda.descTipologia':
    'El color cruza la accesibilidad que la celda conserva con α = 0,5 y la parte de su población diurna que llega a trabajar. Al fijar α = 0,5, no cambia con los botones de α.',
  'leyenda.itemPrimerOrden': 'Primer orden: acceso desde la celda elegida',
  'leyenda.itemSegundoOrden': 'Segundo orden: acceso desde donde trabajan sus residentes',

  'matriz.ejeY': 'accesibilidad retenida',
  'matriz.ejeX': 'peso de la poblacion trabajadora',

  'modal.cerrar': 'Cerrar',
  'modal.explicacion': 'Explicacion',
  'modal.anterior': 'ANTERIOR',
  'modal.siguiente': 'SIGUIENTE',
  'modal.iniciar': 'INICIAR',

  'info.intro': 'Qué es esta interfaz',
  'info.e2sfca': 'Qué es el índice E2SFCA',
  'info.alpha': 'Qué es el parámetro alpha',
  'info.tipologia': 'Qué significa la tipología',
  'info.segundoOrden': 'Qué es el segundo orden',
  'info.escaneo': 'Qué muestra el escaneo',

  'tipo.mixto': 'Centro de uso mixto',
  'tipo.residencial': 'Zona residencial bien servida',
  'tipo.monofuncional': 'Distrito monofuncional de empleo',
  'tipo.desatendida': 'Zona desatendida',
  'tipo.media': 'Accesibilidad media',
  'tipo.mediaAltoPeso': 'Accesibilidad media, peso alto',
};

const en = {
  'idioma.otro': 'ES',
  'idioma.cambiar': 'Cambiar a castellano',

  'comun.residentes': 'RESIDENTS',
  'comun.trabajadores': 'WORKERS',
  'comun.accesibilidad': 'ACCESSIBILITY',
  'comun.tipologia': 'TYPOLOGY',
  'comun.colapsar': 'Collapse the panel',
  'comun.expandir': 'Expand the panel',
  'comun.cargando': 'LOADING DATA...',
  'comun.cargandoCorto': 'Loading...',
  'comun.error': 'DATA LOADING ERROR',

  'orden.primero': 'FROM HOME',
  'orden.segundo': 'FROM WORKPLACE',

  'necesidad.farmacias': 'PHARMACIES',
  'necesidad.supermercados': 'SUPERMARKETS',
  'necesidad.bancos': 'BANKS',
  'necesidad.salud': 'HEALTH',
  'necesidad.farmacias.corta': 'PHA',
  'necesidad.supermercados.corta': 'SUP',
  'necesidad.bancos.corta': 'BAN',
  'necesidad.salud.corta': 'HEA',

  'app.marca': 'LOICA // SANTIAGO A.T. FIELD',
  'app.marcaCorta': 'LOICA // A.T. FIELD',
  'app.acercaAria': 'About this visualisation',
  'app.selectorAlfa': 'WORKER DEMAND (α)',
  'app.codigoAcerca': 'SYSTEM // ABOUT',
  'app.acercaMd': 'acerca-de.en.md',
  'app.acercaError': 'The text could not be loaded.',
  'app.titulo': 'Santiago A.T. Field - Commuter-adjusted accessibility',

  'tooltip.residentes': 'residents',
  'tooltip.trabajadores': 'workers',
  'tooltip.caminata': 'min on foot',

  'panel.espera': 'SELECT A CELL',
  'panel.esperaMovil': 'TAP A CELL',
  'panel.sector': 'SECTOR',
  'panel.completo': 'ANALYSIS COMPLETE',
  'panel.escaneando': 'SCANNING...',
  'panel.progresoAria': 'Walking minutes scanned',
  'panel.min': 'MIN',
  'panel.tabsAria': 'Panel sections',
  'panel.tabAnalisis': 'ANALYSIS',
  'panel.tabServicios': 'SERVICES',
  'panel.puntuacion': 'E2SFCA SCORE',
  'panel.puntuacionPorAlfa': 'SCORE BY α',
  'panel.celda': 'CELL',
  'panel.ciudad': 'CITY',
  'panel.tipologia': 'TYPOLOGY',
  'panel.retenida': 'RETAINED ACCESSIBILITY',
  'panel.peso': 'WORKING-POPULATION WEIGHT',
  'panel.poblacion': 'CELL POPULATION',
  'panel.serviciosEncendidos': 'SERVICES REACHED',
  'panel.sinSenales': 'NO SIGNALS YET',
  'panel.serviciosAlcanzados': 'SERVICES REACHED',
  'panel.trabajadoresResidentes': 'EMPLOYED RESIDENTS',
  'panel.celdasTrabajo': 'WORKPLACE CELLS',
  'panel.serviciosDesdeTrabajo': 'SERVICES FROM WORKPLACES',
  'panel.soloDesdeTrabajo': 'REACHED ONLY FROM WORKPLACES',
  'panel.soloDesdeTrabajoCorto': 'ONLY FROM WORKPLACES',
  'panel.servicios': 'SERVICES',
  'panel.destino': 'DESTINATION',
  'panel.sinAsignacion': 'NO HOME-WORK ASSIGNMENT DATA',
  'panel.verEnMapa': 'SHOW ON MAP',

  'leyenda.titulo': 'HEXAGON COLOUR',
  'leyenda.acerca': 'ABOUT',
  'leyenda.movimientoSi': 'MOTION: ON',
  'leyenda.movimientoNo': 'MOTION: OFF',
  'leyenda.movimientoAria': 'Turn the scan animation on or off',
  'leyenda.residentesPorCelda': 'RESIDENTS PER CELL',
  'leyenda.trabajadoresPorCelda': 'WORKERS PER CELL',
  'leyenda.accesibilidadRampa': 'ACCESSIBILITY (E2SFCA)',
  'leyenda.descPoblacion':
    'Colour shows how many people live in the cell, according to the 2024 census cartography.',
  'leyenda.descTrabajadores':
    'Colour shows how many people work in the cell. The count comes from the 2024 census, distributed within each commune by a spatial prior.',
  'leyenda.descAccesibilidad':
    'Colour shows how well the cell is connected on foot to pharmacies, supermarkets, banks and health centres. The score weighs supply against demand, and its level depends on α.',
  'leyenda.descTipologia':
    'The colour crosses the accessibility a cell retains at α = 0.5 with the share of its daytime population that arrives to work. It fixes α = 0.5, so the α buttons do not change it.',
  'leyenda.itemPrimerOrden': 'From home: access from the selected cell',
  'leyenda.itemSegundoOrden': 'From the workplace: access from where its residents work',

  'matriz.ejeY': 'retained accessibility',
  'matriz.ejeX': 'working-population weight',

  'modal.cerrar': 'Close',
  'modal.explicacion': 'Explanation',
  'modal.anterior': 'BACK',
  'modal.siguiente': 'NEXT',
  'modal.iniciar': 'START',

  'info.intro': 'What this interface shows',
  'info.e2sfca': 'What the E2SFCA score is',
  'info.alpha': 'What the alpha parameter is',
  'info.tipologia': 'What the typology means',
  'info.segundoOrden': 'What the commuter adjustment is',
  'info.escaneo': 'What the scan shows',

  'tipo.mixto': 'Mixed-use centre',
  'tipo.residencial': 'Well-served residential area',
  'tipo.monofuncional': 'Monofunctional employment district',
  'tipo.desatendida': 'Underserved area',
  'tipo.media': 'Medium accessibility',
  'tipo.mediaAltoPeso': 'Medium accessibility, high weight',
};

const TEXTOS = { es, en };

export default TEXTOS;
